module.exports = __webpack_public_path__ + "autoalert-logo-ford.3f4370dc5f325590ae1a.png";